<div class="container p-4">
    <div class="text-center d-flex justify-content-between">
        <button (click)="close()" class="back-btn col-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
              <path d="M19 12H5M12 19l-7-7 7-7"/>
            </svg>
           
          </button>
          <h3 style=" color: #080b53;">{{data.docType | uppercase}}</h3>
        <div class="col-2 text-end" mat-dialog-close><i class="bi bi-x-circle" ></i></div>
       
    </div>
    <div style="width: 100%; max-height: 50%" class="text-center">
        @if(data.contentType && data.contentType.includes('image')){
            <img  *ngIf="imgData != undefined" [src]="imgData" style="object-fit:contain;height: 500px;width: 500px;"/>
        }@else if(  data.contentType=='application/pdf'){
            <ngx-extended-pdf-viewer *ngIf="pdfUrl != undefined" [src]="pdfUrl"
          [textLayer]="true" [showHandToolButton]="true" [showUnverifiedSignatures]="true"> 
        </ngx-extended-pdf-viewer>
        }
        
        
    </div>
</div>
